import { useQuery } from "react-query";
import { RelatorioUnidadePessoa } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioUnidadesPessoas(unidadeId: string, enabled: boolean) {
  return useQuery<{ pessoas: RelatorioUnidadePessoa[] }, AxiosError>(
    [`/v1/relatorios/unidades/${unidadeId}/pessoas`],
    async () => {
      const { data } = await http.get<{ pessoas: RelatorioUnidadePessoa[] }>(
        `/v1/relatorios/unidades/${unidadeId}/pessoas`
      );

      return data;
    },

    { enabled }
  );
}

export default useRelatorioUnidadesPessoas;
